import { call, put, takeLatest } from "redux-saga/effects";
import { DOCUMENT_URL } from "../../helpers/url_api_helper";
import { WORKFLOW } from "./actionTypes"
import { putWorkflowChangeStatus } from "./actions";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* changeWorkflowStatus({ payload }) {
    const { idDocument, type } = payload;
    try {
        if (type === "Review") {
            yield call(DOCUMENT_URL.putDocumentReview, idDocument);
        } else if (type === "Approved") {
            yield call(DOCUMENT_URL.putDocumentApproved, idDocument);
        } else if (type === "Rejected") {
            yield call(DOCUMENT_URL.putDocumentReject, idDocument); 
        } else if (type === "Publish") {
            yield call(DOCUMENT_URL.putDocumentPublish, idDocument);
        } else {
            yield call(DOCUMENT_URL.putDocumentObsolete, idDocument);
        }

        yield put(putWorkflowChangeStatus.success(true));
    } catch (error) {
        yield put(
            putWorkflowChangeStatus.fail(
                normalizeApiError(
                    error,
                    "Something went wrong changing the document's workflow status, please try again later",
                ),
            )
        )
    } 
}

function* WorkflowSaga() {
    yield takeLatest(WORKFLOW.PUT_WORKFLOW_CHANGE_STATUS.REQUEST, changeWorkflowStatus);
}

export default WorkflowSaga;